import { FC, useEffect } from 'react'

interface Props {
  targetId: string
}

const ScrollTo: FC<Props> = ({ targetId }) => {
  useEffect(() => {
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return <div id={targetId} />
}

export default ScrollTo
